/**
 * Central registry of every replaceable image on the site.
 * Each slot has a stable key, a human label (shown in the admin panel),
 * a category (for grouping), and the default URL used until the admin overrides it.
 */
export const IMAGE_SLOTS = [
  // Hero TV wall (7 screens)
  { slot: "hero-1", category: "Hero TV Wall", label: "Screen 1 · Airport",
    default: "https://images.unsplash.com/photo-1436491865332-7a61a109cc05?ixlib=rb-4.1.0&auto=format&fit=crop&w=800&q=80" },
  { slot: "hero-2", category: "Hero TV Wall", label: "Screen 2 · Mall",
    default: "https://images.unsplash.com/photo-1604355714851-c1d5990e1696?ixlib=rb-4.1.0&auto=format&fit=crop&w=800&q=80" },
  { slot: "hero-3", category: "Hero TV Wall", label: "Screen 3 · Cinema",
    default: "https://images.unsplash.com/photo-1517604931442-7e0c8ed2963c?ixlib=rb-4.1.0&auto=format&fit=crop&w=800&q=80" },
  { slot: "hero-4", category: "Hero TV Wall", label: "Screen 4 · XMLOOPS TV (centre)",
    default: "https://images.unsplash.com/photo-1545164415-0fae860defbd?ixlib=rb-4.1.0&auto=format&fit=crop&w=800&q=80" },
  { slot: "hero-5", category: "Hero TV Wall", label: "Screen 5 · Hotel",
    default: "https://images.unsplash.com/photo-1445019980597-93fa8acb246c?ixlib=rb-4.1.0&auto=format&fit=crop&w=800&q=80" },
  { slot: "hero-6", category: "Hero TV Wall", label: "Screen 6 · Studio",
    default: "https://images.unsplash.com/photo-1478720568477-152d9b164e26?ixlib=rb-4.1.0&auto=format&fit=crop&w=800&q=80" },
  { slot: "hero-7", category: "Hero TV Wall", label: "Screen 7 · Fine dining",
    default: "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?ixlib=rb-4.1.0&auto=format&fit=crop&w=800&q=80" },

  // TVFan showcase
  { slot: "tvfan-1", category: "XMLOOPS TV Fan", label: "Fan 1 · Studio A",
    default: "https://images.unsplash.com/photo-1545164415-0fae860defbd?ixlib=rb-4.1.0&auto=format&fit=crop&w=800&q=80" },
  { slot: "tvfan-2", category: "XMLOOPS TV Fan", label: "Fan 2 · Airport",
    default: "https://images.unsplash.com/photo-1436491865332-7a61a109cc05?ixlib=rb-4.1.0&auto=format&fit=crop&w=800&q=80" },
  { slot: "tvfan-3", category: "XMLOOPS TV Fan", label: "Fan 3 · Mall",
    default: "https://images.unsplash.com/photo-1604355714851-c1d5990e1696?ixlib=rb-4.1.0&auto=format&fit=crop&w=800&q=80" },
  { slot: "tvfan-4", category: "XMLOOPS TV Fan", label: "Fan 4 · Cinema (centre)",
    default: "https://images.unsplash.com/photo-1517604931442-7e0c8ed2963c?ixlib=rb-4.1.0&auto=format&fit=crop&w=800&q=80" },
  { slot: "tvfan-5", category: "XMLOOPS TV Fan", label: "Fan 5 · Hotel",
    default: "https://images.unsplash.com/photo-1445019980597-93fa8acb246c?ixlib=rb-4.1.0&auto=format&fit=crop&w=800&q=80" },
  { slot: "tvfan-6", category: "XMLOOPS TV Fan", label: "Fan 6 · Studio B",
    default: "https://images.unsplash.com/photo-1478720568477-152d9b164e26?ixlib=rb-4.1.0&auto=format&fit=crop&w=800&q=80" },
  { slot: "tvfan-7", category: "XMLOOPS TV Fan", label: "Fan 7 · Fine dining",
    default: "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?ixlib=rb-4.1.0&auto=format&fit=crop&w=800&q=80" },

  // Owned Media LED wall
  { slot: "owned-hero", category: "Owned Media", label: "LED wall — hero image",
    default: "https://images.unsplash.com/photo-1545164415-0fae860defbd?ixlib=rb-4.1.0&auto=format&fit=crop&w=1400&q=85" },
  { slot: "owned-feed-1", category: "Owned Media", label: "Side feed 1",
    default: "https://images.unsplash.com/photo-1436491865332-7a61a109cc05?ixlib=rb-4.1.0&auto=format&fit=crop&w=800&q=80" },
  { slot: "owned-feed-2", category: "Owned Media", label: "Side feed 2",
    default: "https://images.unsplash.com/photo-1478720568477-152d9b164e26?ixlib=rb-4.1.0&auto=format&fit=crop&w=800&q=80" },
  { slot: "owned-feed-3", category: "Owned Media", label: "Side feed 3",
    default: "https://images.unsplash.com/photo-1517604931442-7e0c8ed2963c?ixlib=rb-4.1.0&auto=format&fit=crop&w=800&q=80" },
  { slot: "owned-feed-4", category: "Owned Media", label: "Side feed 4",
    default: "https://images.unsplash.com/photo-1445019980597-93fa8acb246c?ixlib=rb-4.1.0&auto=format&fit=crop&w=800&q=80" },

  // Case studies
  { slot: "case-1", category: "Case Studies", label: "Case 1 · Hospitality",
    default: "https://images.unsplash.com/photo-1515703944563-dbcfbf121b3d?ixlib=rb-4.1.0&auto=format&fit=crop&w=900&q=85" },
  { slot: "case-2", category: "Case Studies", label: "Case 2 · Automotive",
    default: "https://images.unsplash.com/photo-1545164415-0fae860defbd?ixlib=rb-4.1.0&auto=format&fit=crop&w=900&q=85" },
  { slot: "case-3", category: "Case Studies", label: "Case 3 · Luxury retail",
    default: "https://images.unsplash.com/photo-1604355714851-c1d5990e1696?ixlib=rb-4.1.0&auto=format&fit=crop&w=900&q=85" },
  { slot: "case-4", category: "Case Studies", label: "Case 4 · BFSI",
    default: "https://images.unsplash.com/photo-1762417419967-d5ccd2ebe463?ixlib=rb-4.1.0&auto=format&fit=crop&w=900&q=85" },
];

/**
 * Real TV channel partners — used for the logo wall.
 * Rendered via DuckDuckGo's icon service (unmetered) with Google favicon + text fallbacks.
 */
export const CHANNEL_PARTNERS = [
  { name: "JioHotstar", domain: "hotstar.com" },
  { name: "SonyLIV", domain: "sonyliv.com" },
  { name: "Amazon Prime", domain: "primevideo.com" },
  { name: "MX Player", domain: "mxplayer.in" },
  { name: "Colors", domain: "colorstv.com" },
  { name: "JioTV", domain: "jio.com" },
  { name: "Hungama TV", domain: "hungama.com" },
  { name: "Samsung TV", domain: "samsung.com" },
  { name: "Roku TV", domain: "roku.com" },
  { name: "Google TV", domain: "google.com" },
  { name: "Apple TV", domain: "apple.com" },
  { name: "MTV", domain: "mtv.com" },
  { name: "9XM TV", domain: "9xm.tv" },
];
